import(/* webpackMode: "eager" */ "/vercel/path0/app/quote/page.tsx");
